import { useCallback } from "react"

export default function useAgendaCalendarController({
  lastCalendarDateRef,
  setDate
}) {
  const handleDatesSet = useCallback((info) => {
    const current = info.view?.currentStart
    if (!current) return

    const y = current.getFullYear()
    const m = String(current.getMonth() + 1).padStart(2, "0")
    const d = String(current.getDate()).padStart(2, "0")
    const visibleDate = `${y}-${m}-${d}`

    lastCalendarDateRef.current = visibleDate
    setDate((prev) => (prev === visibleDate ? prev : visibleDate))
  }, [lastCalendarDateRef, setDate])

  return {
    handleDatesSet
  }
}